export class JobProgressStepScanningBucketData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "scanType",
            "baseName": "scanType",
            "type": "JobProgressStepScanningBucketDataScanTypeEnum",
            "format": ""
        },
        {
            "name": "supportedObjectCount",
            "baseName": "supportedObjectCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "storageSizeBytes",
            "baseName": "storageSizeBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepScanningBucketData.attributeTypeMap;
    }
    constructor() {
    }
}
export var JobProgressStepScanningBucketDataScanTypeEnum;
(function (JobProgressStepScanningBucketDataScanTypeEnum) {
    JobProgressStepScanningBucketDataScanTypeEnum["Full"] = "full";
    JobProgressStepScanningBucketDataScanTypeEnum["Cdc"] = "cdc";
    JobProgressStepScanningBucketDataScanTypeEnum["Inventory"] = "inventory";
    JobProgressStepScanningBucketDataScanTypeEnum["InventoryAndCdc"] = "inventory_and_cdc";
})(JobProgressStepScanningBucketDataScanTypeEnum || (JobProgressStepScanningBucketDataScanTypeEnum = {}));
